import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { buildIssueId } from '../utilities/issue-id';
import { deleteIssue } from '../utilities/issue-managers';

/**
 * Action to clear any "not-found" issue for the salesRepId.
 */
export function clearSalesRepIdIssue(
  state: WritableDraft<QuoteBuilderStateType>,
) {
  const notFoundIssueId = buildIssueId({
    area: 'quote',
    field: 'salesRepId',
    type: 'not-found',
  });
  deleteIssue(state, notFoundIssueId);
}
